<div id="w3l-appointment" style="width: 1000px;">
<section class="appointment-section section-gap" >
  <div class="wrapper doctor-appointment">
    <div class="form-inner-cont">
      <h1>{{'Vacation Request' | translate }}</h1>
    </div>
  <BR>
  <BR>
    <div class="styled-input" >
      <div class="appointment-form-field">
        <label style="width: 15%;">Serial</label>
        <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"(click)="OpenDialog()"></span>
        <input type="text" name="PreparationOrderId" placeholder="Preparation Order Id" style="width: 20%;"required [(ngModel)]="vacnumber" (change)="RertiveVacTrans()">
        <label style="width: 2%;"></label>
        <label style="width: 15%;">Document Date</label>
        <span class="fa fa-calendar" aria-hidden="true" (click)="OpenDialog()"></span>
        <input type="date" name="PreparationOrderIdCpy" style="width: 20%;" required [(ngModel)]="vacdate">
      </div>
    </div>
    <div class="styled-input" >
      <div class="appointment-form-field">
        <label style="width: 15%;">{{'Doctor Code' | translate}}</label>
        <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"(click)="SwithDialog1()"></span>
        <input type="text" name="PreparationOrderId" placeholder="Doctor Code" style="width: 20%;"required [(ngModel)]="vacempcode" (click)="RetriveEmployee()">
        <label style="width: 2%;"></label>
        <label style="width: 15%;">Doctor Name</label>
        <label style="width: 40%;border-style: solid;border-width: .3px;height: 45px;; background-color: #d9e8ff;border-color: #8194df; border-radius: 5%;">{{empname}}</label>
      </div>
    </div>

  <!-- <div class="example-full-width" style="width: 80%;">
    <mat-form-field class="example-full-width" appearance="fill" style="width: 91%;">
      <mat-label style="color:rgb(52, 52, 105);font-weight: bold;">{{'Department' | translate}}</mat-label>
      <input matInput id="srname" style="color:rgb(52, 52, 105);" maxlength="50ch" [(ngModel)]="wk_DepartmentName" (click)="RetriveAltEmployee()">
    </mat-form-field>

  </div > -->
  <!-- <div class="example-full-width" style="width: 80%;">
    <mat-form-field class="example-full-width" appearance="fill" style="width: 31%;">
      <mat-label style="color:rgb(52, 52, 105);font-weight: bold;">{{'Vacation Type' | translate}}</mat-label>
      <mat-select matNativeControl class="example-label" [(ngModel)]="vactype" (selectionChange)="RetriveBalance()" >
        <mat-option *ngFor="let GL of Vaction_List" value="{{GL.vcode}}" >{{GL.vname}}</mat-option>
      </mat-select>
    </mat-form-field>

    <label style="width: 27%;" ></label>
  </div> -->
  <div class="styled-input" >
    <div class="appointment-form-field">
      <label style="width: 15%;">{{'Opening Balance' | translate}}</label>
      <label style="width: 25%;border-style: solid;border-width: .3px;height: 45px;; background-color: #d9e8ff;border-color: #8194df;border-radius: 5%;padding-top: 1%;">{{vacopenbalnce}}</label>
      <label style="width: 4%;"></label>
      <label style="width: 14%;">{{'Transactions' | translate}}</label>
      <label style="width: 20%;border-style: solid;border-width: .3px;height: 45px;; background-color: #d9e8ff;border-color: #8194df;border-radius: 5%;padding-top: 1%;">{{vactransactions}}</label>
      <label style="width: 1%;"></label>
      <label style="width: 8%;">{{'Balance' | translate}}</label>
      <label style="width: 10%;border-style: solid;border-width: .3px;height: 45px;; background-color: #d9e8ff;border-color: #8194df;border-radius: 5%;padding-top: 1%;">{{vacbalance}}</label>

    </div>
  </div>


  <div class="styled-input" >
    <div class="appointment-form-field">
      <label style="width: 15%;">{{'From Date' | translate}}</label>
      <input type="date" name="PreparationOrderIdCpy" style="width: 25%;" required [(ngModel)]="vacfrom" (change)="Calculate_No_OfDays()">
      <label style="width: 4%;"></label>
      <label style="width: 14%;">{{'From Date' | translate}}</label>
      <input type="date" name="PreparationOrIdCpy" style="width: 20%;" required [(ngModel)]="vacto" (change)="Calculate_No_OfDays()">
      <label style="width: 1%;"></label>
      <label style="width: 8%;">{{'Days' | translate}}</label>
      <label style="width: 10%;border-style: solid;border-width: .3px;height: 45px;; background-color: #d9e8ff;border-color: #8194df;border-radius: 5%;padding-top: 1%;">{{vacdays}}</label>

    </div>
  </div>
  <div class="styled-input" >
    <div class="appointment-form-field">
      <label style="width: 15%;">{{'Notes' | translate}}</label>
      <input type="text" name="notes" style="width: 82%;" required [(ngModel)]="vacnote"  >

    </div>
  </div>
  <div class="styled-input" >
    <div class="appointment-form-field">
      <label style="width: 15%;">{{'Alternative ' | translate}}</label>
      <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"(click)="SwithDialog2()"></span>
      <input type="text" name="PreparationOrderId" placeholder="Doctor Code" style="width: 20%;"required [(ngModel)]="vacaltemp" (change)="RetriveAltEmployee()">
      <label style="width: 2%;"></label>
      <label style="width: 15%;">Doctor Name</label>
      <label style="width: 40%;border-style: solid;border-width: .3px;height: 45px;; background-color: #d9e8ff;border-color: #8194df; border-radius: 5%;">{{vacaltempname}}</label>
    </div>
  </div>


  <div class="example-full-width" style="width: 80%;">
    <input type="checkbox" name="concet" [(ngModel)]="wk_Approved" style="width: 25px;height: 25px;"  required="" />{{'Approved' | translate}}


  </div>
<BR>
  <BR>
    <form class="example-button-container" style="width: 100%; text-align: center;" >

      <button mat-raised-button style="width:15%;background-color:#18048d;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="New_Data()"
      >{{'New' | translate}} </button>
      <label style="width: 1.5%;"></label>
      <button mat-raised-button style="width:15%;background-color:#0f7b0d;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="Save_Data()" >
       {{'Save' | translate}}</button>
       <label style="width: 1.5%;"></label>
       <button mat-raised-button style="width:15%;background-color:#ad1608;color: #fffffe; height: 50px; font-size: 85%;font-weight: bolder;" (click)="mesgDelete()"
      >{{'Delete' | translate}}</button>
    </form>

  </div>
  </section>
</div>






